var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_vm._v(" "+_vm._s(_vm.getTypeCaption())+" ")]),_c('div',{staticClass:"col-8 d-flex align-items-center"},[(_vm.isInProgress())?_c('b-progress',{staticClass:"w-100",attrs:{"value":_vm.model.progress,"max":_vm.model.total,"show-progress":"","animated":""}}):_vm._e(),_c('div',{class:[
          'px-4 text-center',
          { 'bg-primary text-white': _vm.isPending(), 'bg-success text-white': _vm.isDone() },
        ]},[_vm._v(" "+_vm._s(_vm.getStateCaption())+" ")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }